import { render, staticRenderFns } from "./StockLogs.vue?vue&type=template&id=574afeca&scoped=true"
import script from "./StockLogs.vue?vue&type=script&lang=js"
export * from "./StockLogs.vue?vue&type=script&lang=js"
import style0 from "./StockLogs.vue?vue&type=style&index=0&id=574afeca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574afeca",
  null
  
)

export default component.exports